import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';
import FormField from '../../../forms/FormField';
import { Button, Row } from 'react-bootstrap';

import AssetSection from './AssetSection';
import AssetTags from './AssetTags';

const getValidation = (validate) => {
  return new Function(`return ${validate}`)();
}

const validate = (values, props) => {
  const { asset } = props || {};
  const { opts } = asset || {};

  if (!opts || !opts.validate) return {};

  const validate = getValidation(opts.validate);

  const errors = validate(values);

  return errors;
}

const AssetForm = props => {
  const { handleSubmit, pristine, submitting, asset, readOnly, CancelButton } = props;
  const { opts } = asset || {};
  const { label, fields, showTags } = opts || {};
  return (
    <form onSubmit={handleSubmit}>
      {showTags && (
        <AssetTags readOnly={readOnly} isRoot />
      )}
      <div className="asset-preview">
        <Row>
          <FormSection name="data">
            <AssetSection asset={asset} readOnly={readOnly} />
          </FormSection>
        </Row>
      </div>
      {!readOnly && (
        <div className="text-right">
          {CancelButton && <CancelButton />}
          {' '}
          <Button bsStyle="success" type="submit" disabled={submitting}>
            <span className="ti ti-check" /> Submit
          </Button>
        </div>
      )}
    </form>
  );
};

export default reduxForm({
  form: 'asset-form', // a unique identifier for this form
  validate,                // <--- validation function given to redux-form
  // warn                     // <--- warning function given to redux-form
})(AssetForm);



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/AssetForm.js